import {
  CONTRACTOR_PAGE_ROOT_PATH,
  ContractorTab,
  SUB_CONTRACTOR_PAGE_ROOT_PATH,
} from "@/constants";
import { NavigationTab } from "@/components/navigation-tabs/types";

export const contractorLayoutTabsConfig: NavigationTab<ContractorTab>[] = [
  {
    id: ContractorTab.Contractor,
    link: `${CONTRACTOR_PAGE_ROOT_PATH}`,
    label: "Contractor Profile",
  },
  {
    id: ContractorTab.Subcontractor,
    link: `${SUB_CONTRACTOR_PAGE_ROOT_PATH}`,
    label: "Subcontractors Management",
  },
];
